import { isInrCurrency } from './currency';
import {COUNTRY_CODE_INDIA} from "../common/constant";
import {get, isFunction, trim} from "lodash";

const countryOption = {
  us: 'US',
  jp:'JP',
  in:'IN',
  other: 'OTHER',
};

export const isValidUSZip = (zipCode = "") => {
  return /(^\d{5}$)/.test(trim(zipCode));
}

export const isValidJPZip = (zipCode = "") => {
  return /(^[0-9-]*$)/.test(trim(zipCode));
}

export const isValidINZip = (zipCode = "") => {
  return /(^\d{6}$)/.test(trim(zipCode));
}

const validZipWithCountry = {
  [countryOption.us]: {
    validFn: isValidUSZip,
    i18nKey: 'billing.invalid_zip',
  },
  [countryOption.jp]: {
    validFn: isValidJPZip,
    i18nKey: 'billing.invalid_jp_zip',
  },
  [countryOption.in]: {
    validFn: isValidINZip,
    i18nKey: 'billing.invalid_in_zip',
  },

};
export const inrCountryValidator = (rule, value, callback) => {
  if (value && isInrCurrency() && value !== COUNTRY_CODE_INDIA) {
    callback(new Error(rule.message));
  } else {
    callback();
  }
};
export const emptyValidator = (rule, value, callback) => {
  if (!value || value.trim() === '') {
    callback(new Error(rule.message));
  } else {
    callback();
  }
};

export const emailValidator = (str) => {
  if (/^([A-Za-z0-9_\-.^*+=`~|{}?\\/'\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/.test(str)) {
    return !(str.includes('.@') || str.startsWith('.'))
  }
  return false
}

export const addEmailValidator = (str) => {
  const hasError = (str.split(',')).some(e => {
    const trimVal = e.trim()
    const regV = /^([A-Za-z0-9_\-.^*+=`~|{}?\\/'\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/.test(trimVal)
    return !regV || trimVal.includes('.@') || trimVal.startsWith('.')
  })
  return !hasError
}

export const validZipCode = (formValue = {}) => {
  const { country, zip } = formValue;
  const { validFn, i18nKey = "" } = get(validZipWithCountry, country, {});
  if (isFunction(validFn) && !validFn(zip)) {
    return i18nKey;
  }
}
